:host {
  width: 100%;
  display: flex;
}

.wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  font-family: var(--type-sans);
}

.label {
  font-size: var(--type-scale-12);
  margin-bottom: var(--spacing-03);
}

.field {
  display: flex;
  background-color: var(--color-field-primary);
  border-style: solid;
  border-color: transparent;
  border-bottom-color: var(--color-border-layer-primary);
  border-width: 1px;
  padding-right: var(--spacing-05);
  padding-left: var(--spacing-05);
  align-items: center;
}

.field.active, .field.focus {
  border-color: var(--color-border-interactive);
  border-width: 2px;
  margin: -1px;
}

.field > .input {
  flex: 1;
  line-height: var(--spacing-08);
  background-color: var(--color-field-primary);
  border: none;
  outline: none;
  font-size: var(--type-scale-14);
}

.field > .input.sm{
  line-height: var(--spacing-07);
}

.field > .input.lg {
  line-height: var(--spacing-09);
}

.field > .state {

}

.helper-text {
  margin-top: var(--spacing-02);
  font-size: var(--type-scale-12);
}